<template>
  <div class="taskProcess">
    <template v-if="isQueue">
      <prePage></prePage>
    </template>
    <template v-else>
      <processAnimateExample @revoke="revoke"></processAnimateExample>
    </template>
  </div>
</template>

<script>
import {mapMutations, mapState} from "vuex";
import {checkDeduction} from "@/api/common";
import {getStatus, getCatelogue, getEvaluation} from "@/api/pdf";
import prePage from "@/views/pdf/processPage/prePage";
import processAnimateExample from "@/views/pdf/processPage/processAnimateExample";
export default {
  name: "taskProcess",
  components:{
    prePage,
    processAnimateExample
  },
  data() {
    return {
      isQueue: true,
      timer: null,
      isGetCatelogue: false,
      isGetEvaluation: false,
      isGetBaseData: false,
      deduction: false
    }
  },
  mounted() {
    this.getStatus();
  },
  methods: {
    async getStatus() {
      try {
        let res = await getStatus({
//           project: "79b067b0-db95-45da-8494-3fcbbb0b8e81",
// sign_name: 1710312137,
          project: this.projectId,
          sign_name: this.sign_name,
          timeStamp: (new Date()).getTime()
        })
        let status = res.data.process;
        this.setProcessData(res.data);
        if (status < 100) {
          switch (status) {
              // 排队阶段
            case 0:
              this.isQueue = true;
              break;
              // 进入文件下载文件阶段 ,将下载文件过程放入排队等待过程中
            case 1:
              this.isQueue = true;
              break;
              // 文件下载完成，结束排队，进入预估阶段，可以调取文件目录接口，界面显示文件节点动画，
            case 2:
              await this.getCatelogue()
              this.isQueue = false;
              break;
            case 3:
              // pdf解析中
              await this.getCatelogue();
              await this.getEvaluation();
              this.isQueue = false;
              break;
            case 4:
              // 解析完成
              await this.getCatelogue();
              await this.getEvaluation();
              this.isQueue = false;
              break;
            default:
              // 可能错过中间过程  直接取
              await this.getCatelogue();
              
              await this.getEvaluation()
              this.isQueue = false;
              break;

          }
          this.timer = setTimeout(() => {
            this.getStatus()
          }, 5000)
        } else {
          this.isQueue = false;
          
          await this.getCatelogue()
          await this.getEvaluation()
          // 设置过程结束
          this.setFinished(true)
          this.checkDeduction();
          console.log('结束了')
        }
      } catch (err) {
        console.log(err)
      }
    },
    /**
     * 获取文件目录
     */
    async getCatelogue() {
      let res = await getCatelogue({
        // project: "79b067b0-db95-45da-8494-3fcbbb0b8e81",
        // sign_name: 1710312137
        project: this.projectId,
        sign_name: this.sign_name
      })
      this.setCatelogueData(res.data)
      console.log('文件节点信息',res)
    },
    /**
     * 获取评估信息
     */
    async getEvaluation() {
      let res = await getEvaluation({
        // project: "79b067b0-db95-45da-8494-3fcbbb0b8e81",
        // sign_name: 1710312137
        project: this.projectId,
        sign_name: this.sign_name
      })
      this.setEvaluationData(res.data)
      console.log('任务评估信息',res)
    },
    /**
     * 查询是否扣次
     */
    async checkDeduction(){
      let res = await checkDeduction({
        // project: "79b067b0-db95-45da-8494-3fcbbb0b8e81",
        // sign_name: 1710312137
        project: this.projectId,
        sign_name: this.sign_name
      });
      if(res.data){
        await this.$router.push("/pdfResultExample")
        // await this.$router.push('/pdfMiddleResult')
      }else{
        await this.$router.push('/pdfMiddleResult')
      }
    },
    revoke(){
      clearTimeout(this.timer);
      this.$router.push({
        name:"Home",
        params:{
          init:true
        }
      })
    },
    ...mapMutations('pdf', ['setProcessData', 'setEvaluationData',  'setFinished', 'setCatelogueData'])
  },
  destroyed() {
    clearTimeout(this.timer)
  },
  computed: {
    ...mapState("user", ['serviceInfo']),
    ...mapState("pdf", ["projectId", 'sign_name'])
  }
}
</script>

<style lang="scss" scoped>
.taskProcess {
  flex: 1;
  height: 1px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

}
</style>
